// import { useEffect } from "react";

import { getCaseId, getClientId } from "../../../../Utils/helper";
import ClientIcon from "../../../../../public/BP_resources/images/icon/client-icon-color.svg";
import PlaceHolderifNothingAdded from "../../../components-new-final/placeholder-nothing-added";
// import TableLoader from "../../../Loaders/tableLoader";
// import useClientPage from "../contact-panel/hooks/useClientPage";

// import { useCounselTypes } from "./hooks/useOpposingCounsel";
import CounselMain from "./components/counsel-main";

const PriorCounselNew = ({ clientData, refetch, setShowPriorCounselModal }) => {
  const currentCase = getCaseId();
  const client = getClientId();

  const handleFetchWitnesses = () => {
    refetch(currentCase, client);
  };

  if (!clientData?.client?.prior_counsels?.length) {
    return (
      <PlaceHolderifNothingAdded
        text1={"No Prior Counsels Added"}
        text2={"Click to Add"}
        pageIcon={ClientIcon}
        onClick={() => setShowPriorCounselModal(true)}
      />
    );
  }

  return (
    <div className="border-box-wrap w-100">
      {clientData?.client?.prior_counsels?.map((data) => (
        <CounselMain
          key={data.id}
          page="Client"
          object={data}
          name={`${clientData?.client?.first_name || ""} ${clientData?.client?.last_name || ""}`}
          handleFetchWitnesses={handleFetchWitnesses}
        />
      ))}
    </div>
  );
};

export default PriorCounselNew;
